module.exports = __webpack_public_path__ + "static/tutorial-slide-1-562b6199abff06c57252ea1a075a1f8f.png";